import useParseURL from 'hooks/useParseURL';
import {WeightUnits} from 'interfaces';
import {SingleSelect} from './SingleSelect';
import {useTranslation} from 'react-i18next';
import {useFilterContext} from 'context/FilterContext';
import {DEFAULT_WEIGHT_UNIT} from 'appConstants';

export const WeightUnitSelector = () => {
  const {urlSearchParams, pathname, navigate} = useParseURL();
  const filterContext = useFilterContext();

  const {t} = useTranslation('common');

  const setUnit = (unit: WeightUnits) => {
    filterContext.weightUnit = unit;
    navigate({
      pathname,
      search: urlSearchParams.toString(),
    });
  };
  return (
    <SingleSelect
      selectedKey={filterContext.weightUnit ?? DEFAULT_WEIGHT_UNIT}
      options={
        new Map([
          [WeightUnits.hog, t(WeightUnits.hog)],
          [WeightUnits.lwe, t(WeightUnits.lwe)],
        ])
      }
      onClick={(value) => {
        setUnit(value);
      }}
      align="right"
      dataTestId="weight-unit-single-select"
    />
  );
};
